export const serviceReminderData = {
  clinic: {
    logo: 'https://firebasestorage.googleapis.com/v0/b/televet-v2.appspot.com/o/clinics%2F-Lv6W8zrAMQgk6qQ5sZN?alt=media&token=c044b31b-42b7-4d38-bafa-a14691ab6810',
  },
  servicesList: [
    {
      petName: 'Roxy',
      services: [
        {
          name: 'Service 1',
          date: '04/11/2021',
          beforeDue: true,
          pastDue: false,
        },
        {
          name: 'Service 2',
          date: '04/11/2021',
          beforeDue: true,
          pastDue: false,
        },
        {
          name: 'Service 3',
          date: '04/11/2021',
          beforeDue: false,
          pastDue: true,
        },
      ],
    },
    {
      petName: 'Bruno',
      services: [
        {
          name: 'Service 1',
          date: '04/11/2021',
          beforeDue: true,
          pastDue: false,
        },
        {
          name: 'Service 2',
          date: '04/11/2021',
          beforeDue: false,
          pastDue: true,
        },
      ],
    },
  ],
};
